/// <reference path="typings/jquery.d.ts" />
/// <reference path="typings/quarkplayer.d.ts" />
///<reference path="commons/xhr.ts" />
var Share = /** @class */ (function () {
    function Share() {
        this.fbAppId = "2077390426415844";
        this.twitterUsername = "tv2resmi";
        this.baseDomain = "https://www.tv2.com.tr";
        if (document.querySelector('.section-photo-gallery-detail') !== null) {
            this.photoGalleryShareListener();
        }
        if (document.querySelector('.section-video-play-detail') !== null || document.querySelector('.section-video-playlist-detail') !== null) {
            this.videoDetailListener();
        }
    }
    Share.prototype.photoGalleryShareListener = function () {
        var _this = this;
        var facebookElements = document.querySelectorAll('.social-media-blocks .icon-facebook');
        var twitterElements = document.querySelectorAll('.social-media-blocks .icon-x');
        var nextElements = document.querySelectorAll('.social-media-blocks .next-social');
        var title = document.querySelector('.desc-wrapper .desc-title').textContent;
        var description = document.querySelector('.nano-content').textContent;
        var url = this.baseDomain + window.location.pathname;
        var picElement = document.querySelector('.section-photo-gallery-detail');
        var picture = picElement.dataset.shareImage;
        picture = "http:" + picture;
        /* jshint ignore:start */
        for (var i = 0; i < facebookElements.length; i++) {
            facebookElements[i].addEventListener("click", function () {
                _this.facebookShare(title, description, url, picture);
            });
        }
        for (var t = 0; t < twitterElements.length; t++) {
            twitterElements[t].addEventListener("click", function () {
                _this.twitterShare(title);
            });
        }
        for (var t = 0; t < nextElements.length; t++) {
            nextElements[t].addEventListener("click", function () {
                _this.nextShare(title, url);
            });
        }
        /* jshint ignore:end */
    };
    Share.prototype.videoDetailListener = function () {
        var _this = this;
        var facebookElements = document.querySelectorAll('.social-media-blocks .icon-facebook');
        var twitterElements = document.querySelectorAll('.social-media-blocks .icon-x');
        var nextElements = document.querySelectorAll('.social-media-blocks .next-social');
        var embedCopyButtons = document.querySelectorAll('.embed-copy-button');
        var title = document.querySelector('.desc-wrapper .desc-title').textContent;
        var description = "";
        if (embedCopyButtons.length != 0) {
            var copyFunction = function (value) {
                var input_temp = document.createElement("input");
                input_temp.value = value;
                document.body.appendChild(input_temp);
                input_temp.select();
                document.execCommand("copy");
                document.body.removeChild(input_temp);
            };
            var copiedEmbedUrl_1 = document.getElementById('input-iframe-code').value;
            var copyButtonTexts_1 = document.querySelectorAll('.embed-copy-button > span');
            var icons_1 = document.querySelectorAll('.embed-copy-button > .icon');
            var _loop_1 = function (i) {
                embedCopyButtons[i].addEventListener('click', function () {
                    copyFunction(copiedEmbedUrl_1);
                    icons_1[i].classList.remove('icon-copy');
                    icons_1[i].classList.add('icon-checkmark');
                    embedCopyButtons[i].classList.add('copied');
                    copyButtonTexts_1[i].textContent = "KOPYALANDI";
                    setTimeout(function () {
                        embedCopyButtons[i].classList.remove('copied');
                        copyButtonTexts_1[i].textContent = "KOPYALA";
                        icons_1[i].classList.remove('icon-checkmark');
                        icons_1[i].classList.add('icon-copy');
                    }, 3000);
                });
            };
            for (var i = 0; i < embedCopyButtons.length; i++) {
                _loop_1(i);
            }
        }
        if (document.querySelector('.nano-content p') !== null) {
            description = document.querySelector('.nano-content p').textContent;
        }
        else if (document.querySelector('.desc-info.readmore') !== null) {
            description = document.querySelector('.desc-info.readmore').textContent;
        }
        var url = this.baseDomain + window.location.pathname;
        var picElement = document.querySelector('.section-video-play-detail');
        if (picElement === null) {
            picElement = document.querySelector('.section-video-playlist-detail');
        }
        var picture = picElement.dataset.shareImage;
        picture = "http:" + picture;
        /* jshint ignore:start */
        for (var i = 0; i < facebookElements.length; i++) {
            facebookElements[i].addEventListener("click", function () {
                _this.facebookShare(title, description, url, picture);
            });
        }
        for (var t = 0; t < twitterElements.length; t++) {
            twitterElements[t].addEventListener("click", function () {
                _this.twitterShare(title);
            });
        }
        for (var t = 0; t < nextElements.length; t++) {
            nextElements[t].addEventListener("click", function () {
                _this.nextShare(title, url);
            });
        }
        /* jshint ignore:end */
        $('.social-media-blocks .icon-embed').on('click', function (ev) {
            ev.preventDefault();
            $(this).parent().find('.share-embed-url').toggleClass('show');
        });
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.share-embed-url').length && !$(e.target).closest('.icon-embed').length) {
                $('.share-embed-url').removeClass('show');
            }
        });
    };
    Share.prototype.facebookShare = function (title, description, url, picture) {
        var shareProto = "https://www.facebook.com/dialog/feed?app_id=" +
            this.fbAppId +
            "&display=popup&link=" +
            url +
            "&redirect_uri=" +
            url +
            "&title=" +
            title +
            "&description=" +
            description +
            "&picture=" +
            picture;
        window.open(shareProto, 'facebook', 'toolbar=0,status=0,width=650,height=436');
        return false;
    };
    Share.prototype.twitterShare = function (text) {
        var shareProto = "https://twitter.com/intent/tweet?via=" +
            this.twitterUsername +
            "&text=" +
            text + window.location.href;
        window.open(shareProto, 'twitter', 'toolbar=0,status=0,width=650,height=436');
        return false;
    };
    Share.prototype.nextShare = function (title, url) {
        window.open("https://sosyal.teknofest.app/share?text=" +
            encodeURIComponent(title) +
            "%0A" +
            encodeURIComponent(url), "facebook-share-dialog", "width=626,height=436");
        return false;
    };
    return Share;
}());
var share = new Share();
//# sourceMappingURL=share.js.map